import { TextArea } from 'style-guide/Input';

const ShortEssay = () => <TextArea className='short-essay-textarea' disabled />;

export default ShortEssay;
